export enum Route {
  Root = '/',
  ErrorPage = '/error',
  Doorway = '/doorway'
}
